import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';
import { staggeredFadeIn } from '../../utils/animations';

export function BlogPostCard({ post, index }) {
    return (
        <motion.div {...staggeredFadeIn(index * 0.1)}>
            <Link
                to={`/blog/${post.slug}`}
                className="block h-full bg-white border border-gray-100 rounded-sm p-8 shadow-sm hover:shadow-md hover:border-gold-200 transition-all duration-300 group"
                data-testid={`blog-post-${index}`}
            >
                <div className="flex items-center gap-4 mb-5">
                    <span className="text-gold-400 text-xs font-bold tracking-[0.2em] uppercase">{post.category}</span>
                    <span className="text-gray-300">|</span>
                    <span className="flex items-center gap-1.5 text-[#6B7280] text-xs">
                        <Clock size={12} strokeWidth={1.5} />
                        {post.readTime}
                    </span>
                </div>
                <h2 className="font-montserrat font-bold text-xl text-navy-900 mb-3 group-hover:text-gold-500 transition-colors duration-200">
                    {post.title}
                </h2>
                <p className="text-[#6B7280] text-sm leading-relaxed mb-6">{post.excerpt}</p>
                <div className="flex items-center gap-2 text-navy-900 text-xs font-bold uppercase tracking-widest group-hover:text-gold-400 transition-colors">
                    <span>Read Article</span>
                    <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
                </div>
            </Link>
        </motion.div>
    );
}
